import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import SimpleMDE from 'react-simplemde-editor'
import { FormattedMessage } from 'react-intl'

import AddResource from '../components/activityedit/AddResource'
import UploadMentorFile from '../components/activityedit/UploadMentorFile'
import EditMentorFile from '../components/activityedit/EditMentorFile'
import EditResource from '../components/activityedit/EditResource'
import DraggableListComponent from '../components/mini/DraggableListComponent'
import MultipleEditorsInfo from '../components/quest/multipleeditors/MultipleEditorsInfo'

import { setQuestSection } from '../actions/quest'
import { currentActivity } from '../selectors/activity'
import {
  editActivityDetails,
  deleteActivityMentorNote,
  createQuestActivityNote,
  editQuestActivityNote,
  editQuestActivityNotePosition
} from '../actions/activity'
import {
  createActivityResource,
  deleteActivityResource,
  editActivityResourcePosition,
  editActivityResource,
  removeActivityResourceFile
} from '../actions/resource'
import { patchActivityResourceFileInfo } from '../actions/resource'
import { postLoggingInfo } from '../actions/logging'
import { findActivity } from '../utils/quest'
import { mapResources } from '../utils/resources'
import { activityGoalOrgLabel } from '../utils/orglabels'
import { simpleMDEOptions } from '../utils/index'
import {
  save,
  cancel,
  title,
  descriptionMessage,
  yes,
  no,
  requiresArtifact,
  activityResources,
  addResource,
  justFor,
  mentors,
  notesForMentors,
  uploadFileForMentors,
  assessmentQuestions,
  artifactDescription
} from '../utils/messages'
import { messages as confirmMessages } from '../utils/messages/confirm'
import { messages as alertMessages } from '../utils/messages/alert'
import { messages as placeholderMessages } from '../utils/messages/placeholder'
import { filterCurrentUserFromMembers } from '../utils/multipleeditors'
import { unsubscribeFromAllChannelsWithPrefix } from '../utils/pusher'
import { flashDraggableItem } from '../utils/draggableitem'

class ActivityEditContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activity: props.currentActivity,
      noteToEdit: '',
      resourceToEdit: '',
      newEditors: [],
      artifactType: props.currentActivity.artifact_type
        ? props.currentActivity.artifact_type.id
        : null,
      isEditingResource: false,
      uploadedResourceFile: '',
      isAddingResource: false
    }

    this.onReturnToQuestClickBound = this.onReturnToQuestClick.bind(this)
    this.onAddResourceClickBound = this.onAddResourceClick.bind(this)
    this.onSaveActivityClickBound = this.onSaveActivityClick.bind(this)
    this.onCancelActivityEditClickBound =
      this.onCancelActivityEditClick.bind(this)
    this.handleChangeBound = this.handleChange.bind(this)
    this.handleDescriptionChangeBound = this.handleDescriptionChange.bind(this)
    this.handleCheckpointYesClickBound =
      this.handleCheckpointYesClick.bind(this)
    this.handleCheckpointNoClickBound = this.handleCheckpointNoClick.bind(this)
    this.handleWorkproductYesClickBound =
      this.handleWorkproductYesClick.bind(this)
    this.handleWorkproductNoClickBound =
      this.handleWorkproductNoClick.bind(this)
    this.handleInlineNoteChangeBound = this.handleInlineNoteChange.bind(this)
    this.handleAssessmentQuestionsChangeBound =
      this.handleAssessmentQuestionsChange.bind(this)
    this.onUploadMentorFileClickBound = this.onUploadMentorFileClick.bind(this)
    this.onDeleteNoteClickBound = this.onDeleteNoteClick.bind(this)
    this.onSaveMentorFileUploadClickBound =
      this.onSaveMentorFileUploadClick.bind(this)
    this.closeModalBound = this.closeModal.bind(this)
    this.handleEditNoteClickBound = this.handleEditNoteClick.bind(this)
    this.editMentorNoteBound = this.editMentorNote.bind(this)
    this.onEditActivityNotePositionBound =
      this.onEditActivityNotePosition.bind(this)
    this.onDeleteResourceClickBound = this.onDeleteResourceClick.bind(this)
    this.handleEditResourceClickBound = this.handleEditResourceClick.bind(this)
    this.onEditActivityResourcePositionBound =
      this.onEditActivityResourcePosition.bind(this)
    this.editResourceBound = this.editResource.bind(this)
    this.removeResourceFileBound = this.removeResourceFile.bind(this)
    this.handleArtifactDescriptionChangeBound =
      this.handleArtifactDescriptionChange.bind(this)
    this.editorAddedBound = this.editorAdded.bind(this)
    this.patchFileUploadInfoBound = this.patchFileUploadInfo.bind(this)
    this.deleteShellResourceBound = this.deleteShellResource.bind(this)
    this.stopEditResourceBound = this.stopEditResource.bind(this)
    this.startFileUploadAnalyticsBound =
      this.startFileUploadAnalytics.bind(this)
    this.cancelFileUploadAnalyticsBound =
      this.cancelFileUploadAnalytics.bind(this)
    this.fileUploadCompleteAnalyticsBound =
      this.fileUploadCompleteAnalytics.bind(this)
    this.removeResourceFileAnalyticsBound =
      this.removeResourceFileAnalytics.bind(this)
  }

  componentDidMount() {
    this.presenceChannel =
      window.oeQMQuestPusherInstance &&
      window.oeQMQuestPusherInstance.channel(
        `presence-activity-${this.props.id}`
      )
        ? window.oeQMQuestPusherInstance.channel(
            `presence-activity-${this.props.id}`
          )
        : null
    if (this.presenceChannel) {
      this.presenceChannel.bind('client-edit', this.editorAddedBound)
    }
  }

  componentWillReceiveProps(nextProps) {
    // Wait for the save/edit action to finish before closing the modal
    if (this.props.isUploadingNote && !nextProps.isUploadingNote) {
      this.closeModal()
    }
  }

  componentWillUnmount() {
    if (window.oeQMQuestPusherInstance) {
      unsubscribeFromAllChannelsWithPrefix(
        window.oeQMQuestPusherInstance,
        'presence'
      )
    }
  }

  render() {
    const {
      quest,
      id,
      notes,
      isUploadingNote,
      dispatch,
      currentOrg,
      activities
    } = this.props

    const activity = quest ? findActivity(activities, id) : ''

    const descriptionOptions = Object.assign({}, simpleMDEOptions)
    descriptionOptions.initialValue = activity ? activity.description : ''
    descriptionOptions.placeholder = ''
    descriptionOptions.autofocus = false

    const mentorNoteOptions = Object.assign({}, simpleMDEOptions)
    mentorNoteOptions.initialValue = activity ? activity.inline_notes : ''
    mentorNoteOptions.placeholder = ''
    mentorNoteOptions.autofocus = false

    const mentorAssessmentQuestionsOptions = Object.assign({}, simpleMDEOptions)
    mentorAssessmentQuestionsOptions.initialValue = activity
      ? activity.mentor_assessment_questions
      : ''
    mentorAssessmentQuestionsOptions.placeholder = ''
    mentorAssessmentQuestionsOptions.autofocus = false

    const artifactDescriptionOptions = Object.assign({}, simpleMDEOptions)
    artifactDescriptionOptions.initialValue = activity
      ? activity.artifact_description
      : ''
    artifactDescriptionOptions.placeholder = this.context.intl.formatMessage(
      placeholderMessages.artifactDescription
    )
    artifactDescriptionOptions.autofocus = false

    const mappedResources =
      activity.resources.length > 0 ? mapResources(activity.resources) : []

    return !activity ? (
      <div className="loading" />
    ) : (
      <div className="activity-edit-container">
        <div id="activityActions">
          <div className="nav-to-quest">
            <h5 onClick={this.onReturnToQuestClickBound}>{`< Return to ${
              quest ? quest.name : 'Quest'
            }`}</h5>
          </div>
          <div className="header-title">
            {this.presenceChannel &&
              Object.keys(
                filterCurrentUserFromMembers(
                  this.presenceChannel.members,
                  this.props.user.id
                )
              ).length > 0 && (
                <MultipleEditorsInfo
                  channel={this.presenceChannel}
                  newEditors={this.state.newEditors}
                />
              )}
            <h2>{activity.name}</h2>
          </div>
          <div className="top">
            <div
              className="button save btn-primary"
              onClick={this.onSaveActivityClickBound}
            >
              {save}
            </div>
            <div
              className="button cancel btn-secondary"
              onClick={this.onCancelActivityEditClickBound}
            >
              {cancel}
            </div>
          </div>
        </div>
        <div id="activityContainer">
          <div id="accordion" className="qm-view">
            <div className="quest-section one">
              <div className="section-inner">
                <div className="edit-fields">
                  <div className="title">
                    {title}
                    <div className="requiredtool" />
                  </div>
                  <input
                    type="text"
                    id="name"
                    defaultValue={activity.name}
                    className="form-control"
                    onChange={this.handleChangeBound}
                  />
                </div>

                <div className="title">
                  {activityGoalOrgLabel(currentOrg)}
                  <div className="requiredtool" />
                </div>
                <div className="edit-fields">
                  <input
                    type="text"
                    id="goals"
                    className="form-control"
                    defaultValue={activity.goals}
                    onChange={this.handleChangeBound}
                  />
                </div>

                <div className="title">
                  {descriptionMessage}
                  <div className="requiredtool" />
                </div>
                <div className="edit-fields">
                  <SimpleMDE
                    options={descriptionOptions}
                    onChange={this.handleDescriptionChangeBound}
                  />
                </div>

                <div className="title checkpoint">
                  <FormattedMessage
                    id={'ActivityEdit.Checkpoint?'}
                    defaultMessage={'Check-in?'}
                  />
                </div>
                <div className="edit-fields padded">
                  <div>
                    <input
                      type="radio"
                      id="checkpoint"
                      name="checkpoint"
                      className="form-control"
                      checked={this.state.activity.checkpoint}
                      value={true}
                      onChange={this.handleCheckpointYesClickBound}
                    />
                    <label htmlFor="checkpoint">{yes}</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="checkpoint"
                      name="checkpoint"
                      className="form-control"
                      checked={!this.state.activity.checkpoint}
                      value={false}
                      onChange={this.handleCheckpointNoClickBound}
                    />
                    <label htmlFor="checkpoint">{no}</label>
                  </div>
                </div>

                <div className="title requires-resource">
                  {requiresArtifact}
                </div>
                <div
                  className="edit-fields padded"
                  style={{ position: 'relative' }}
                >
                  <div className="artifact-toggle">
                    <div>
                      <input
                        type="radio"
                        id="work_product"
                        name="work_product"
                        className="form-control"
                        checked={this.state.activity.work_product}
                        value={true}
                        onChange={this.handleWorkproductYesClickBound}
                      />
                      <label htmlFor="work_product">{yes}</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="work_product"
                        name="work_product"
                        className="form-control"
                        checked={!this.state.activity.work_product}
                        value={false}
                        onChange={this.handleWorkproductNoClickBound}
                      />
                      <label htmlFor="work_product">{no}</label>
                    </div>
                  </div>
                  {this.state.activity.work_product && (
                    <React.Fragment>
                      <div className="artifact-type">
                        <div className="title">
                          Artifact Type
                          <div className="requiredtool" />
                        </div>
                        {this.props.artifactTypes.map(at => {
                          return (
                            <div>
                              <label style={{ marginBottom: '0' }}>
                                <input
                                  key={at.id}
                                  type="radio"
                                  id="artifact_type_id"
                                  checked={this.state.artifactType === at.id}
                                  value={at.id}
                                  onClick={this.handleChangeBound}
                                />
                                {at.name}
                              </label>
                            </div>
                          )
                        })}
                      </div>
                      <div className="artifact-description">
                        <div className="title">{artifactDescription}</div>
                        <SimpleMDE
                          options={artifactDescriptionOptions}
                          onChange={this.handleArtifactDescriptionChangeBound}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </div>

                <div className="resource-list">
                  <div className="title">{activityResources}</div>
                  <div
                    className={`add-resource ${
                      this.props.isCreatingActivityResource ||
                      this.state.isAddingResource
                        ? 'disabled'
                        : ''
                    }`}
                    onClick={this.onAddResourceClickBound}
                  >
                    {addResource}
                    {(this.props.isCreatingActivityResource ||
                      this.state.isAddingResource) && (
                      <div
                        className="loading"
                        style={{
                          marginLeft: '10px',
                          height: '17px',
                          width: '17px',
                          backgroundSize: '100%',
                          minHeight: 'unset',
                          display: 'inline-block',
                          verticalAlign: 'text-bottom'
                        }}
                      />
                    )}
                  </div>
                  {this.state.isAddingResource && (
                    <AddResource
                      ref="addResourceModal"
                      organization={currentOrg}
                      resourceId={this.state.resourceToEdit}
                      patchFileUploadInfo={this.patchFileUploadInfoBound}
                      editResource={this.editResourceBound}
                      deleteResource={this.deleteShellResourceBound}
                      removeResourceFile={this.removeResourceFileBound}
                      uploadedResourceFile={this.state.uploadedResourceFile}
                      stopEditResource={this.stopEditResourceBound}
                      questId={quest.id}
                      activityId={id}
                      token={this.props.token}
                      onUploadFileStart={this.startFileUploadAnalyticsBound}
                      onUploadFileAbort={this.cancelFileUploadAnalyticsBound}
                      onUploadComplete={this.fileUploadCompleteAnalyticsBound}
                    />
                  )}
                  {this.state.isEditingResource && (
                    <EditResource
                      ref="editResourceModal"
                      editResource={this.editResourceBound}
                      stopEditResource={this.stopEditResourceBound}
                      organization={currentOrg}
                      removeResourceFile={this.removeResourceFileBound}
                      patchFileUploadInfo={this.patchFileUploadInfoBound}
                      questId={quest.id}
                      activityId={id}
                      resourceId={this.state.resourceToEdit}
                      token={this.props.token}
                      uploadedResourceFile={this.state.uploadedResourceFile}
                      onUploadFileStart={this.startFileUploadAnalyticsBound}
                      onUploadFileAbort={this.cancelFileUploadAnalyticsBound}
                      onUploadComplete={this.fileUploadCompleteAnalyticsBound}
                    />
                  )}
                  <div id="resources-list-section">
                    <DraggableListComponent
                      list={mappedResources}
                      deleteItem={this.onDeleteResourceClickBound}
                      handleEditClick={this.handleEditResourceClickBound}
                      dispatch={dispatch}
                      editListItemPosition={
                        this.onEditActivityResourcePositionBound
                      }
                      itemType={'resource'}
                    />
                  </div>
                </div>

                <div id="justForMentors">
                  <label className="just-for-mentors-label">
                    {justFor}&nbsp;
                    <span className="label">{mentors}</span>
                  </label>
                  <div className="edit-fields">
                    <div className="title">{notesForMentors}</div>
                    <SimpleMDE
                      options={mentorNoteOptions}
                      onChange={this.handleInlineNoteChangeBound}
                    />
                  </div>

                  <div className="edit-fields">
                    <div className="title" id="mentorNoteFileUploadTitle">
                      {uploadFileForMentors}
                    </div>
                    <div id="mentorNotesSection">
                      <div
                        className="add-mentor-note"
                        onClick={this.onUploadMentorFileClickBound}
                      >
                        {notes.length > 0 ? (
                          <FormattedMessage
                            id={'ActivityEdit.AddAnotherFile'}
                            defaultMessage={'Add another file'}
                          />
                        ) : (
                          <FormattedMessage
                            id={'ActivityEdit.AddAFileToHelpMentors'}
                            defaultMessage={
                              'Add a file to help mentors with this activity'
                            }
                          />
                        )}
                      </div>
                      <UploadMentorFile
                        ref="addMentorFileModal"
                        closeModal={this.closeModalBound}
                        saveMentorNote={this.onSaveMentorFileUploadClickBound}
                        isUploadingNote={isUploadingNote}
                      />
                      <EditMentorFile
                        ref="editMentorNoteModal"
                        closeModal={this.closeModalBound}
                        note={this.state.noteToEdit}
                        editMentorNote={this.editMentorNoteBound}
                        isUploadingNote={isUploadingNote}
                      />
                      <DraggableListComponent
                        list={notes}
                        deleteItem={this.onDeleteNoteClickBound}
                        handleEditClick={this.handleEditNoteClickBound}
                        dispatch={dispatch}
                        editListItemPosition={
                          this.onEditActivityNotePositionBound
                        }
                        itemType={'note'}
                      />
                    </div>
                  </div>

                  <div className="title" style={{ marginTop: '40px' }}>
                    {assessmentQuestions}
                  </div>
                  <div className="edit-fields">
                    <SimpleMDE
                      options={mentorAssessmentQuestionsOptions}
                      onChange={this.handleAssessmentQuestionsChangeBound}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div
              className="button save btn-primary"
              onClick={this.onSaveActivityClickBound}
            >
              {save}
            </div>
            <div
              className="button cancel btn-secondary"
              onClick={this.onCancelActivityEditClickBound}
            >
              {cancel}
            </div>
          </div>
        </div>
      </div>
    )
  }

  editorAdded(data) {
    this.setState(prevState => ({
      newEditors: prevState.newEditors.concat({
        id: JSON.stringify(data.id),
        name: data.info.name
      })
    }))
  }

  onReturnToQuestClick() {
    const { dispatch, quest, id } = this.props
    dispatch(push(`/quest/${quest.id}/activities/${id}`))
    dispatch(setQuestSection('activities', id))
  }

  async onAddResourceClick() {
    const { dispatch, quest, currentActivity } = this.props
    const newResourceName =
      currentActivity.resources.length === 0
        ? 'Resource 1'
        : `Resource ${currentActivity.resources.length + 1}`
    await dispatch(
      createActivityResource(quest.id, currentActivity, newResourceName)
    )
    this.setState(() => ({
      resourceToEdit: currentActivity.resources[0].id,
      isAddingResource: true
    }))
  }

  onUploadMentorFileClick() {
    this.refs.addMentorFileModal.refs.modal.show()
  }

  closeModal() {
    this.refs.addMentorFileModal.refs.modal.hide()
    this.refs.editMentorNoteModal.refs.modal.hide()
  }

  onSaveActivityClick() {
    const { dispatch, quest, id } = this.props
    const intlAlert = this.context.intl.formatMessage(
      alertMessages.nameCantBeBlank
    )
    if (this.state.activity.name.length < 1) {
      alert(intlAlert)
    } else {
      dispatch(editActivityDetails(quest.id, id, this.state.activity))
    }
  }

  onCancelActivityEditClick() {
    const { dispatch, quest, id } = this.props
    dispatch(push(`/quest/${quest.id}/activities/${id}`))
    dispatch(setQuestSection('activities', id))
  }

  handleChange(event) {
    if (event.target.id === 'artifact_type_id') {
      const value = parseInt(event.target.value)
      this.setState(() => ({ artifactType: value }))
    }

    this.setState({
      activity: {
        ...this.state.activity,
        [event.target.id]: event.target.value
      }
    })
  }

  handleDescriptionChange(val) {
    this.setState({
      activity: {
        ...this.state.activity,
        description: val
      }
    })
  }

  handleArtifactDescriptionChange(val) {
    this.setState({
      activity: {
        ...this.state.activity,
        artifact_description: val
      }
    })
  }

  handleCheckpointYesClick() {
    this.setState({
      activity: {
        ...this.state.activity,
        checkpoint: true
      }
    })
  }

  handleCheckpointNoClick() {
    // User should be alerted if they're requiring an artifact/workproduct but selecting no checkpoint
    const intlAlert = this.context.intl.formatMessage(
      alertMessages.stronglyRecommendArtifact
    )
    if (this.state.activity.work_product) {
      alert(intlAlert)
    }
    this.setState({
      activity: {
        ...this.state.activity,
        checkpoint: false
      }
    })
  }

  handleWorkproductYesClick() {
    // Defaulting checkpoint to 'yes' if artifact required
    document.getElementById('checkpoint').checked = true
    this.setState({
      activity: {
        ...this.state.activity,
        checkpoint: true,
        work_product: true
      }
    })
  }

  handleWorkproductNoClick() {
    this.setState({
      activity: {
        ...this.state.activity,
        work_product: false,
        artifact_description: null,
        artifact_type: null,
        artifact_type_id: null
      },
      artifactType: null
    })
  }

  handleInlineNoteChange(val) {
    this.setState({
      activity: {
        ...this.state.activity,
        inline_notes: val
      }
    })
  }

  handleAssessmentQuestionsChange(val) {
    this.setState({
      activity: {
        ...this.state.activity,
        mentor_assessment_questions: val
      }
    })
  }

  onDeleteNoteClick(e) {
    const { dispatch, id, quest } = this.props
    // Need to locate the note clicked
    const noteId = parseInt(
      e.target.parentNode.parentNode.parentNode.dataset.id
    )
    const intlConfirmation = this.context.intl.formatMessage(
      confirmMessages.deleteMentorNote
    )
    var confirmation = confirm(intlConfirmation)
    if (confirmation) {
      dispatch(deleteActivityMentorNote(quest.id, id, noteId))
    }
  }

  onSaveMentorFileUploadClick(noteArgs) {
    const { dispatch, id, quest } = this.props
    dispatch(createQuestActivityNote(quest.id, id, noteArgs))
  }

  handleEditNoteClick(note) {
    this.setState({
      noteToEdit: note
    })
    this.refs.editMentorNoteModal.refs.modal.show()
  }

  editMentorNote(noteId, description) {
    const { dispatch, quest, id } = this.props
    dispatch(editQuestActivityNote(quest.id, id, noteId, description))
  }

  onEditActivityNotePosition(noteId, newIndex) {
    const { dispatch, quest, id } = this.props
    dispatch(editQuestActivityNotePosition(quest.id, id, noteId, newIndex))
    // Find the node and flash orange
    var _el = document.getElementById(`note-${noteId}`)
    flashDraggableItem(_el)
  }

  onDeleteResourceClick(e) {
    const { dispatch, quest, id } = this.props
    // find the resource
    const resourceId = parseInt(
      e.target.parentNode.parentNode.parentNode.dataset.id
    )
    const intlConfirmation = this.context.intl.formatMessage(
      confirmMessages.deleteResource
    )
    var confirmation = confirm(intlConfirmation)
    if (confirmation) {
      dispatch(deleteActivityResource(quest.id, id, resourceId))
    }
  }

  onEditActivityResourcePosition(resourceId, newIndex) {
    const { dispatch, quest, id } = this.props
    dispatch(editActivityResourcePosition(quest.id, id, resourceId, newIndex))
    // Find the node and flash orange
    var _el = document.getElementById(`resource-${resourceId}`)
    flashDraggableItem(_el)
  }

  async editResource(resource, newResource) {
    const { dispatch, quest, id } = this.props
    await dispatch(editActivityResource(quest.id, id, resource, newResource))
    this.setState(() => ({
      isAddingResource: false,
      isEditingResource: false,
      resourceToEdit: null,
      uploadedResourceFile: ''
    }))
  }

  async removeResourceFile(resource, source) {
    const { dispatch, quest, id } = this.props
    await dispatch(removeActivityResourceFile(quest.id, id, resource))
    this.setState(() => ({
      uploadedResourceFile: ''
    }))
    this.removeResourceFileAnalytics(resource, source)
  }

  async patchFileUploadInfo(fileProps) {
    const { dispatch, quest, id } = this.props
    const resourceId = this.state.resourceToEdit

    try {
      await dispatch(
        patchActivityResourceFileInfo(quest.id, id, resourceId, fileProps)
      )
      this.setState(() => ({
        uploadedResourceFile: fileProps.original_file_name
      }))
    } catch (e) {
      throw new Error(e)
    }
  }

  deleteShellResource(resourceId) {
    const { dispatch, quest, id } = this.props
    dispatch(deleteActivityResource(quest.id, id, resourceId, true))
    this.setState(() => ({
      isAddingResource: false
    }))
  }

  handleEditResourceClick(resource) {
    this.setState(() => ({
      isEditingResource: true,
      resourceToEdit: resource.id
    }))
  }

  stopEditResource() {
    this.setState(() => ({
      isAddingResource: false,
      isEditingResource: false,
      resourceToEdit: null,
      uploadedResourceFile: ''
    }))
  }

  startFileUploadAnalytics(resource, file) {
    let data = this.getResourceLoggingInfo(resource)
    data = {
      ...data,
      action: 'start_file_upload',
      resource: {
        ...data.resource,
        filename: file.name,
        filesize: file.size
      }
    }

    this.props.dispatch(postLoggingInfo('track_resource', data))
  }

  cancelFileUploadAnalytics(resource, file, source) {
    let data = this.getResourceLoggingInfo(resource)
    data = {
      ...data,
      action: 'cancel_file_upload',
      resource: {
        ...data.resource,
        filename: file.name,
        filesize: file.size
      },
      source
    }

    this.props.dispatch(postLoggingInfo('track_resource', data))
  }

  fileUploadCompleteAnalytics(resource, file, uploadTime) {
    let data = this.getResourceLoggingInfo(resource)
    data = {
      ...data,
      action: 'upload_file',
      resource: {
        ...data.resource,
        filename: file.name,
        filesize: file.size,
        time_to_upload_in_seconds: uploadTime
      }
    }

    this.props.dispatch(postLoggingInfo('track_resource', data))
  }

  removeResourceFileAnalytics(resource, source) {
    let data = this.getResourceLoggingInfo(resource)
    data = {
      ...data,
      resource: {
        ...data.resource,
        filename: resource.fileName
      },
      source,
      action: 'remove_file'
    }

    this.props.dispatch(postLoggingInfo('track_resource', data))
  }

  getResourceLoggingInfo(resource) {
    const { quest, id, activities } = this.props
    const activity = quest ? findActivity(activities, id) : ''
    const currentActivityNumber =
      activities.findIndex(a => a.id === activity.id) + 1
    const data = {
      action: 'remove_file',
      quest: {
        id: quest.id,
        name: quest.name
      },
      activity: {
        id: activity.id,
        name: activity.name,
        number: currentActivityNumber
      },
      resource: {
        id: resource.id,
        name: resource.resourceName,
        format: resource.resourceType
      }
    }
    return data
  }
}

ActivityEditContainer.propTypes = {
  id: PropTypes.number.isRequired,
  quest: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  activityId: PropTypes.number.isRequired,
  notes: PropTypes.array,
  isUploadingNote: PropTypes.bool,
  currentOrg: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  artifactTypes: PropTypes.array.isRequired,
  currentActivity: PropTypes.object.isRequired,
  isCreatingActivityResource: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired,
  activities: PropTypes.array.isRequired
}

ActivityEditContainer.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => ({
  id: parseInt(ownProps.params.activityId),
  quest: state.quest.item,
  notes: state.quest.activityNotes,
  isUploadingNote: state.quest.isUploadingNote,
  currentOrg: state.organizations.items.find(function (org) {
    return org.id === parseInt(state.organization.orgId)
  }),
  user: state.user.user,
  artifactTypes: state.artifacttypes.items,
  currentActivity: currentActivity(state),
  isCreatingActivityResource: state.quest.isCreatingActivityResource,
  token: state.user.token,
  activities: state.quest.activities
})

export default connect(mapStateToProps)(ActivityEditContainer)



// WEBPACK FOOTER //
// ./src/containers/ActivityEdit.js